import React, { useEffect, useState } from "react";
import "./App.css";
import { SERVER_HOST, THEME_0 } from "./utils/constants";
import Dashboard from "./components/Dashboard";
import LoginForm from "./components/LoginForm";
import Loader from "./components/Loader";

export default function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const [username, setUsername] = useState("Шеф");
    const [userRights, setUserRights] = useState({});
    const [isAdmin, setIsAdmin] = useState(0);

    const changeTheme = (theme) => {
        let arr_theme = Object.entries(theme);

        for (let i = 0; i < arr_theme.length; i++) {
            document.documentElement.style.setProperty(
                arr_theme[i][0],
                arr_theme[i][1]
            );
        }
    };

    useEffect(() => {
        changeTheme(THEME_0);
        const checkSession = async () => {
            try {
                const response = await fetch(SERVER_HOST, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    credentials: "include",
                    body: JSON.stringify({ action: "check_session" }),
                });

                const data = await response.json();

                if (data.status === "logged_in") {
                    setUsername(data.username);
                    setUserRights(data.userRights);
                    setIsAdmin(data.urAdmin);
                    setIsAuthenticated(true);
                } else {
                    setIsAuthenticated(false);
                }
            } catch (error) {
                setIsAuthenticated(false);
            }
        };

        checkSession();
    }, []);

    if (isAuthenticated === null) {
        return <Loader />;
    }

    return isAuthenticated ? (
        <Dashboard
            username={username}
            userRights={userRights}
            isAdmin={isAdmin}
        />
    ) : (
        <LoginForm />
    );
}
